import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../theme/theme";

const useLayoutStyles = makeStyles({
  layout: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },

  main: {
    flex: 1,
    // overflow: "auto",
  },

  backToTopBtn: {
    borderRadius: customTokens.borderRadiusCircular,
    background: customTokens.colorBrandBackground2,
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
    color: customTokens.colorBrandBackground,
    padding: "8px 12px",
    position: "fixed",
    bottom: "100px",
    right: "20px",
    zIndex: "999",

    "&:hover": {
      background: customTokens.colorBrandBackground2,
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
      color: customTokens.colorBrandBackground,
    },

    "&:hover:active": {
      background: customTokens.colorBrandBackground2,
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
      color: customTokens.colorBrandBackground,
    },
  },
});

export default useLayoutStyles;
